import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    if ('IntersectionObserver' in window) {
      this.__viewed = false
      this.__observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const input = this.element.querySelector(
              'input[name="survey_response[viewed_at]"]'
            )
            if (input && !this.__viewed) {
              input.value = new Date().toISOString()
              this.__viewed = true
            }
          }
        })
      })
      this.__observer.observe(this.element)
    } else {
      console.warn('IntersectionObserver is not supported')
    }
  }

  disconnect() {
    if (this.__observer) {
      this.__observer.disconnect()
      this.__observer = null
    }
  }
}
